const Client = require("./ModHttpsClient")

module.exports = {
    toOptions(array, locale = "de") {
        let options = []
        for (let i = 0, len = array.length; i < len; i++) {
            options.push({
                value: array[i].id,
                text: array[i].id + " - " + array[i].names[locale]
            })
        }
        return options
    },
    create(data) {
        return Client.post(data, {
            path: "/goods/create",
            required: [
                "names"
            ]
        })
    },
    read(id) {
        return Client.get([
            {
                key: "id",
                value: id
            }
        ], {
            path: "/goods/read"
        })
    },
    readAll(limit, offset = 0) {
        if (typeof limit === 'number') {
            return Client.get([
                {
                    key: "limit",
                    value: limit
                },
                {
                    key: "offset",
                    value: offset
                }
            ], { path: "/goods/read/all" })
        } else {
            return Client.get(null, { path: "/goods/read/all" })
        }
    },
    update(data) {
        return Client.post(data, {
            path: "/goods/update",
            required: [
                "id",
                "names"
            ]
        })
    },
    delete(id) {
        return Client.get([
            {
                key: "id",
                value: id
            }
        ], {
            path: "/goods/delete"
        })
    },
    search(pattern) {
        return Client.get([
            {
                key: "pattern",
                value: pattern
            }
        ], {
            path: "/goods/search"
        })
    },
    count() {
        return Client(null, { path: "/goods/count" })
    },
    moderatorNeeded(goodIds) {
        let array = "{" + JSON.stringify(goodIds).replace(/\[/g, "").replace(/]/g, "") + "}"        
        return Client.get([
            {
                key: "ids",
                value: array
            }
        ], {
            path: "/goods/moderator"
        })
    },
    deliveryAddressNeeded(goodIds) {
        let array = "{" + JSON.stringify(goodIds).replace(/\[/g, "").replace(/]/g, "") + "}"
        return Client.get([
            {
                key: "ids",
                value: array
            }
        ], {
            path: "/goods/deliveryaddress"
        })
    },
    copy(id, name) {
        return Client.get([
            {
                key: "id",
                value: id
            },
            {
                key: "name",
                value: name
            }
        ], {
            path: "/goods/copy"
        })
    },
    isUsed(id) {
        return Client.get([
            {
                key: "id",
                value: id
            }
        ], {
            path: "/goods/isused"
        })
    },
    availableUrls() {
        return Client.get(null, {
            path: "/goods/available/urls"
        })
    },
    mapToUlr(id, url) {
        return Client.get([
            {
                key: "id",
                value: id
            },
            {
                key: "url",
                value: url
            }
        ], {
            path:"/goods/map/url"
        })
    },
    unmapFromUrl(id, url) {
        return Client.get([
            {
                key: "id",
                value: id
            },
            {
                key: "url",
                value: url
            }
        ], {
            path:"/goods/unmap/url"
        })
    },
    mappedUrls(id) {
        return Client.get([
            {
                key: "id",
                value: id
            }
        ], {
            path: "/goods/mapped/urls"
        })
    },
    list(languageId = "en"){
        return Client.get([
            {
                key: "lang",
                value: languageId
            }
        ], {
            path: "/goods/list"
        })
    }

}